import React from "react";

function StoryUploadTypes(props) {
  return (
    <div>
      <text style={{ fontWeight: "bold" }}>Type:</text>
      <div style={{ marginRight: 10 }}>
        <input
          value={props.selectedtype}
          type="radio"
          checked={props.selectedtype == "Image"}
          onChange={() => {
            props.handleType("Image", props.sectionIndex);
          }}
        ></input>
        <text for={"Image"}>{"Image"}</text>
      </div>
      {props.selectedContentType == "Story" ||
      props.selectedContentType == "liveNews" ? (
        <>
          <div style={{ marginRight: 10 }}>
            <input
              value={props.selectedtype}
              type="radio"
              checked={props.selectedtype == "Video"}
              onChange={() => {
                props.handleType("Video", props.sectionIndex);
              }}
            ></input>
            <text for={"Video"}>{"Video"}</text>
          </div>
          <div style={{ marginRight: 10 }}>
            <input
              value={props.selectedtype}
              type="radio"
              checked={props.selectedtype == "youtubeID"}
              onChange={() => {
                props.handleType("youtubeID", props.sectionIndex);
              }}
            ></input>
            <text for={"youtubeID"}>{"youtubeID"}</text>
          </div>
        </>
      ) : null}
      {props.selectedContentType == "Story" ? (
        <div style={{ marginRight: 10 }}>
          <input
            value={props.selectedtype}
            type="radio"
            checked={props.selectedtype == "imageTemplate"}
            onChange={() => {
              props.handleType("imageTemplate");
            }}
          ></input>
          <text for={"imageTemplate"}>{"imageTemplate"}</text>
        </div>
      ) : null}
    </div>
  );
}

export default StoryUploadTypes;
